import React, { useEffect } from 'react'
import * as QueryString from 'query-string'
import { navigate, useLocation } from '@reach/router'
import { ApiPut } from './Common/Api'

const EmailLinkTracker: React.FC = () => {
    const { search, pathname } = useLocation()
    useEffect(() => {
        if (!search) return

        const qs = QueryString.parse(search)
        if(!qs['n'] || !qs['e']) return

        const emailID = parseInt(qs['n'] as string)
        const emailAddress = qs['e'] as string

        if(emailID && emailAddress)
        {
            // eslint-disable-next-line no-console
            ApiPut(`Notification/ClickedEmailLink?notificationEmailID=${emailID}&emailToValidate=${emailAddress}`).catch(console.log)
        }

        const q = QueryString.stringify({
            ...qs,
            n: null,
            e: null
        })
        void navigate(`${pathname}?${q}`)
    }, [search, pathname])

    return <></>
}

export default EmailLinkTracker